module.exports = __webpack_public_path__ + "img/drive-dil-1.03553928.svg";